module.exports = ".list-content {\n  display: block;\n  width: 100%;\n}\n.list-group {\n  max-height: 500px;\n  overflow: auto;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/list/list.component.less
// module id = ./src/app/shared/list/list.component.less
// module chunks = main